export default __webpack_public_path__ + "static/media/Dopagut-60-ml-eng.a42632c1.jpg";